export default __webpack_public_path__ + "64b1d619e3ed7afac1b806a9f5e0d0fe.png";